<router-outlet></router-outlet>
<ngx-loading
  [show]="spinner.showSpinner"
  [config]="loadingConfig"
></ngx-loading>
